var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 10,
    fill: "#F0F9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1927 33.9912L25.8132 30.1281C26.3194 28.7587 26.3197 27.2422 25.8132 25.8719L32.1927 22.0087C35.1478 24.8895 40.1164 22.7757 40.1164 18.668C40.1165 16.094 38.0225 14 35.4484 14C32.3376 14 30.078 17.0094 30.977 20.0066L24.5974 23.87C23.4705 22.6271 21.844 21.8453 20.0382 21.8453C16.6445 21.8453 13.8835 24.6062 13.8835 28C13.8835 31.3937 16.6445 34.1547 20.0382 34.1547C21.844 34.1547 23.4705 33.3728 24.5974 32.13L30.977 35.9934C30.0793 38.9863 32.3332 42 35.4484 42C38.0224 42 40.1165 39.906 40.1165 37.332C40.1165 33.218 35.1444 31.1139 32.1927 33.9912ZM35.4484 16.3422C36.7309 16.3422 37.7743 17.3855 37.7743 18.668C37.7743 19.9504 36.731 20.9938 35.4484 20.9938C34.1659 20.9938 33.1227 19.9505 33.1227 18.668C33.1227 17.3855 34.1661 16.3422 35.4484 16.3422ZM20.0381 31.8123C17.936 31.8123 16.2257 30.1021 16.2257 27.9999C16.2257 25.8977 17.9359 24.1875 20.0381 24.1875C22.1404 24.1875 23.8505 25.8977 23.8505 27.9999C23.8505 30.1021 22.1404 31.8123 20.0381 31.8123ZM35.4484 39.6577C34.1659 39.6577 33.1227 38.6144 33.1227 37.332C33.1227 36.0495 34.166 35.0061 35.4484 35.0061C36.7309 35.0061 37.7743 36.0495 37.7743 37.332C37.7743 38.6144 36.731 39.6577 35.4484 39.6577Z",
    fill: "#66C9CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(13 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.51b565c66f8971d9230d0f52bcf13279.svg";
export { ForwardRef as ReactComponent };